import { IIcon } from './iconConstants'
export const Seat2Icon = (props: IIcon) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 18 16'
      fill={'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 13.25V15m8-1.75V15M2.6 6.114C1.8 6.13 1 6.487 1 7.125v3.5c0 1.45 1.075 2.625 2.4 2.625h11.2c1.325 0 2.4-1.175 2.4-2.625v-3.5c0-.71-.8-1.029-1.6-1.011m-12.8 0c.8-.018 1.6.3 1.6 1.011 0 1.193.2 2.625 1.778 2.625h6.044c1.578 0 1.778-1.432 1.778-2.625 0-.639.8-.993 1.6-1.011m-12.8 0V3.625C2.6 2.175 3.675 1 5 1h8c1.325 0 2.4 1.175 2.4 2.625v2.489'
        stroke={props.fill}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
